import React, { useState, useMemo } from 'react';
import { FilterElementAttributes } from '../types/FilterElementAttributes';
import { Range, getTrackBackground } from 'react-range';
import {
  IRenderThumbParams,
  IRenderTrackParams,
} from 'react-range/lib/types';

const FilterRangeSlider = ({
  filter,
  onChange,
}: FilterElementAttributes) => {
  const [values, setValues] = useState<number[]>([
    parseInt(
      (filter.options.length == 4
        ? filter.options[2]?.id
        : filter.options[0]?.id) ?? '0'
    ),
    parseInt(
      (filter.options.length == 4
        ? filter.options[3]?.id
        : filter.options[1]?.id) ?? '0'
    ),
  ]);
  const [onChangeTimer, setOnChangeTimer] = useState<NodeJS.Timeout>();

  // Store the initial min and max value
  const minValue = useMemo(
    () => parseInt(filter.options[0]?.id ?? '0'),
    []
  );
  const maxValue = useMemo(
    () => parseInt(filter.options[1]?.id ?? '0'),
    []
  );

  const onRangeChanged = (values: number[]) => {
    setValues(values);

    if (onChange) {
      if (onChangeTimer) {
        clearTimeout(onChangeTimer);
      }

      // Debounce onChange
      setOnChangeTimer(
        setTimeout(() => {
          onChange(filter.id, values);
        }, 350)
      );
    }
  };

  const renderThumb = ({
    props,
    isDragged,
    value,
  }: IRenderThumbParams) => (
    <div
      {...props}
      className="flex h-10 w-10 items-center justify-center rounded bg-white text-lg text-gray-900 shadow-[0_2px_6px_#000] shadow-gray-600"
      style={{ ...props.style }}
    >
      <div>{value}</div>
    </div>
  );

  const renderTrack = ({ props, children }: IRenderTrackParams) => (
    <div
      className="flex h-9 w-full"
      onMouseDown={props.onMouseDown}
      onTouchStart={props.onTouchStart}
      style={{ ...props.style }}
    >
      <div
        className="h-[5px] w-full self-center rounded"
        style={{
          background: getTrackBackground({
            values: values,
            colors: ['#ccc', '#548BF4', '#ccc'],
            min: minValue,
            max: maxValue,
          }),
        }}
        ref={props.ref}
      >
        {children}
      </div>
    </div>
  );

  if (minValue <= maxValue) return null;

  return (
    <Range
      values={values}
      min={minValue}
      max={maxValue}
      onChange={onRangeChanged}
      renderThumb={renderThumb}
      renderTrack={renderTrack}
    />
  );
};

export default FilterRangeSlider;
